import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import load from "../../assets/Images/loader.gif";

const optionSolutation = [
  { label: "Select Salutation", value: "0" },
  { label: "Mr.", value: "1" },
  { label: "Mrs.", value: "2" },
  { label: "Miss", value: "3" },
];
const optionState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const optionLeadChannel = [
  { label: "Select Channel", value: "" },
  { label: "Call/SMS-Inbound", value: "Call/SMS-Inbound" },
  { label: "Caretel", value: "Caretel" },
  { label: "CM Outbound", value: "CM Outbound" },
  { label: "Email/Email Campaigns", value: "Email/Email Campaigns" },
  { label: "Inside Sales", value: "Inside Sales" },
  { label: "Inside Sales-QC", value: "Inside Sales-QC" },
  { label: "FFA APP", value: "FFA APP" },
  { label: "NetOps Channel", value: "NetOps Channel" },
  { label: "Online CAF", value: "Online CAF" },
  { label: "Outbound Call", value: "Outbound Call" },
  { label: "Paid Campaign/Activity", value: "Paid Campaign/Activity" },
  {
    label: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
    value: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
  },
  { label: "Self Care Portal", value: "Self Care Portal" },
  { label: "Self Lead", value: "Self Lead" },
  { label: "Unify Churned", value: "Unify Churned" },
  { label: "Web Campaign", value: "Web Campaign" },
];



const optionQualify = [
  // { name: "Disqualify", code: "" },
  { name: "Not Interested", code: "569480000" },
  { name: "Delay in Response", code: "569480002" },
  { name: "Pricing issue", code: "569480003 " },
  { name: "Location Is Non-RFS", code: " 569480004" },
  { name: "Existing Customer", code: "569480007 " },
  { name: "Customer Is defaulter", code: "569480008" },
  { name: "Broadband/Home user", code: "569480010" },
  { name: "Duplicate Lead", code: "569480011" },
  { name: "Incomplete information", code: "569480012 " },
  { name: "Wrong Number", code: "569480014 " },
  { name: "Not Contactable", code: "569480015" },
  { name: "Language Barrier", code: "569480016" },
];

const BroadbandLeadForm = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  const [openForm, setOpenForm] = useState("form1");
  const [userData, setUserData] = useState({
    fullName: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    block: "",
    houseNo: "",
    floor: "",
    portalCode: "",
    remark: "",
    specifyLeadSource : ""
  });
  const [loading, setLoading] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [loader, setLoader] = useState(false);
  const [selectRelationship, setSelectRelationship] = useState("");
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const [selectIndustryType, setSelectIndustryType] = useState("");
  const [industryTypes, setIndustryTypes] = useState([]);
  const [selectFirmType, setSelectFirmType] = useState("");
  const [firmTypes, setFirmTypes] = useState([]);
  const [selectSolutation, setSelectSolutation] = useState(optionSolutation[0]);
  const [selectCity, setSelectCity] = useState("");
  const [cityType, setCityType] = useState([]);
  const [selectState, setSelectState] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [societyList, setSocietyList] = useState([]);
  const [selectSociety, setSelectSociety] = useState("");
  const [selectSource, setSelectSource] = useState("");
  const [status, setStatus] = useState(null);
  const [flrStatus, setFlrStatus] = useState(null);
  const [comName, setComName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [relationShipId, setRelationShipId] = useState("");
  const [getGroup, setGetGroup] = useState("");
  const [getCity, setGetCity] = useState("");
  const [getDigiCompanyId, setGetDigiCompanyId] = useState("");
  const [selectLeadChannel, setSelectLeadChannel] = useState(
    optionLeadChannel[0]
  );
  const [optionSource, setOptionSource] = useState("");
  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  // const handleIconClick = (formId) => {
  //   if (openForm !== formId) {
  //     setOpenForm(formId);
  //   }
  // };

  const handleIconClick = (formId) => {
    setOpenForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  const handleSelectIndustryType = (selectIndustryType) => {
    setSelectIndustryType(selectIndustryType);
  };

  const handleSelectChannel = (select) => {
    setSelectLeadChannel(select);
    setSelectSource("")
  };

  const handleSelectFirmType = (selectFirmType) => {
    setSelectFirmType(selectFirmType);
  };
  const handleSelectSolutation = (selectSolutation) => {
    setSelectSolutation(selectSolutation);
  };

  const handleSelectSociety = (selectSociety) => {
    setSelectSociety(selectSociety);
  };
  const handleSelectSource = (selectSource) => {
    setSelectSource(selectSource);
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        // lead source API call
        const leadSourceApiUrl = process.env.REACT_APP_API_URL;
        const leadSourceRequestBody = {
          Action: "getSource",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          channelName: selectLeadChannel.value,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const leadSourceResponse = await fetch(leadSourceApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(leadSourceRequestBody),
        });
        const leadSourceData = await leadSourceResponse.json();
        // console.log("lead Source :", leadSourceData.Response.Data);
        // Check if data is not undefined or null before mapping
        if (leadSourceData.Response.Data) {
          // Transforming data into the required format
          const transformedOptions = leadSourceData.Response.Data.map(
            (option) => ({
              label: option.SourceName,
              value: option.SourceName,
            })
          );
          // console.log("setLeadSourceOptions",transformedOptions)
          setOptionSource(transformedOptions);

        } else {
          // If data is undefined or null, set leadSourceOptions to an empty array
          setOptionSource([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectLeadChannel]);



  const fetchCompanyData = async () => {
    try {
      setLoader(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getCompany",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: "New Company",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      //console.log("conpany name :", data.Response.Data);
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((company) => ({
          label: `${company.Company_Name} (${company.Company_ID})`,
          value: company.Company_ID,
          group: `${company.Group_Name} (${company.Group_ID})`,
          groupId: company.Group_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoader(false);
    }
    return [];
  };


  useEffect(() => {
    const loadOptions = async () => {
      const options = await fetchCompanyData("");
      setCompanyOptions(options);
    };
    loadOptions();
  }, []);

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  useEffect(() => {
    // Update group options when selectedCompany changes
    if (selectedCompany) {
      setGroupOptions([
        { label: selectedCompany.group, value: selectedCompany.groupId },
      ]);
    } else {
      setGroupOptions([]);
    }
  }, [selectedCompany]); // Only trigger the effect when selectedCompany changes


  const fetchRelationshipData = async (companyId) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getRelationship",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: companyId,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((relationship) => ({
          label: relationship.Relationship_Name,
          value: relationship.Relationship_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching relationship data:", error);
    }
    return [];
  };

  useEffect(() => {
    const loadRelationships = async () => {
      // console.log("selectedCompany",selectedCompany);
      if (selectedCompany) {
        const relationshipOptions1 = await fetchRelationshipData(
          selectedCompany.value
        );
        // console.log("relationshipOptions1",relationshipOptions1);
        setRelationshipOptions(relationshipOptions1);
      }
    };
    loadRelationships();
  }, [selectedCompany]);


  const handleGroupChange = (selectedOption) => {
    setSelectedGroup(selectedOption);
  };
  const handleSelectRelationship = (selectRelationship) => {
    setSelectRelationship(selectRelationship);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Industry API call
        const industryTypeApiUrl = process.env.REACT_APP_API_URL;
        const industryTypeRequestBody = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const industryTypeResponse = await fetch(industryTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(industryTypeRequestBody),
        });
        const industryTypeData = await industryTypeResponse.json();
        // setIndustryTypes(industryTypeData.Response);
        // console.log("industryTypeData :",industryTypeData.Response)
        if (industryTypeData.Response) {

          const transformedOptions = industryTypeData.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          setIndustryTypes(transformedOptions);
          // console.log("transformedOptions",transformedOptions)
        } else {
          setIndustryTypes([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const firmTypeApiUrl = process.env.REACT_APP_API_URL;
        const firmTypeRequestBody = {
          Action: "firmTypeList",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          userName: sessionStorage.getItem("userName"),
          password: sessionStorage.getItem("password")
        }
        const firmTypeResponse = await fetch(firmTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(firmTypeRequestBody),
        });
        const firmTypeData = await firmTypeResponse.json();
        // console.log("firmTypeData.Response.Data", firmTypeData.Response.Data);

        if (firmTypeData.Response.Data) {

          const transformedOptions = firmTypeData.Response.Data.map(
            (option) => ({
              label: option.Text,
              value: option.Value,
            })
          );
          setFirmTypes(transformedOptions);
          // console.log("transformedOptions",transformedOptions)
        } else {
          setFirmTypes([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleSelectState = (selectedState) => {
    setSelectState(selectedState);
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem("password"),
          stateCode: selectState.value,
          userName: sessionStorage.getItem("userName"),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityType(cityData.Response.Data);
          // setSelectArea([]);
        } else {
          console.error(
            "City data structure not recognized:",
            cityData.Response
          );
          setCityType([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    // Fetch cities only if a state is selected
    if (selectState) {
      fetchCities();
    }
  }, [selectState]);



  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCity(selectedOption);
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL_2;
      const areaRequestBody = {
        Action: "getarea",
        Authkey: "AdgT6SnjAkeLqlkE4",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem("password"),
        restrictedarea: true,
        stateCode: "",
        userName: sessionStorage.getItem("userName"),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response)) {
        // console.log("area :", areaData.Response);
        setAreaList(areaData.Response);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectArea = async (selectArea) => {
    // const selectedAreaCode = selectArea ? selectArea.value : "";
    // console.log("selectedAreaCode", selectArea.value);
    setSelectArea(selectArea);
    setSelectSociety([]);
    // try {
    //   const societyApiUrl = process.env.REACT_APP_API_URL_2;
    //   const societyRequestBody = {
    //     Action: "getsociety",
    //     Authkey: "AdgT6SnjAkeLqlkE4",
    //     areaCode: selectedAreaCode,
    //     password: sessionStorage.getItem("password"),
    //     userName: sessionStorage.getItem("userName"),
    //   };
    //   const societyResponse = await fetch(societyApiUrl, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(societyRequestBody),
    //   });
    //   const societyData = await societyResponse.json();
    //   // console.log("societyData.Response",societyData.Response)
    //   // console.log("societyData.Response",societyData.Message)
    //   if (societyData.Response && Array.isArray(societyData.Response)) {
    //     setSocietyList(societyData.Response);
    //   } else {
    //     toast.warning(societyData.Message, {
    //       position: toast.POSITION.BOTTOM_CENTER,
    //       autoClose: 1500,
    //     });
    //     setSocietyList([]);
    //   }
    // } catch (error) {
    //   console.error("Error fetching area data:", error);
    // }
  };



  const fetchSocietyData = async (selectedAreaCode) => {
    try {
      const societyApiUrl = process.env.REACT_APP_API_URL_2;
      const societyRequestBody = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: selectedAreaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
      const societyResponse = await fetch(societyApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(societyRequestBody),
      });
      const societyData = await societyResponse.json();
      // console.log("societyData.Response", societyData.Response);
      if (societyData.Response && Array.isArray(societyData.Response)) {
        setSocietyList(societyData.Response);
      } else {
        toast.warning(societyData.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setSocietyList([]);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
      setSocietyList([]);
    }
  };


  useEffect(() => {
    if (selectArea) {
      const selectedAreaCode = selectArea.value ? selectArea.value : "";
      // console.log("selectedAreaCode",selectedAreaCode);
      fetchSocietyData(selectedAreaCode);
    }
  }, [selectArea]);




  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const leadId = searchParams.get("LeadId");

  useEffect(() => {
    const fetchData = async () => {
      try {

        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL_2;
        const requestBody = {
          Action: "getleads",
          Authkey: "AdgT6SnjAkeLqlkE4",
          ContactId: "",
          leadId: leadId,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        // console.log("LeadChannel", data?.Response[0]?.LeadChannel);
        setSelectLeadChannel({
          value: data?.Response[0]?.LeadChannel,
          label: data?.Response[0]?.LeadChannel,
        });
        setSelectSource({
          value: data?.Response[0]?.LeadSource,
          label: data?.Response[0]?.LeadSource,
        });
        setSelectState({
          value: data?.Response[0]?.installationAddress?.InstallState,
          label: data?.Response[0]?.installationAddress?.InstallStateName,
        });
        setSelectCity({
          value: data?.Response[0]?.installationAddress?.InstallCity,
          label: data?.Response[0]?.installationAddress?.InstallCityName,
        });
        setSelectArea({
          value: data?.Response[0]?.installationAddress?.InstallArea,
          label: data?.Response[0]?.installationAddress?.InstallAreaName,
        });
        // console.log("Broadband getLeads", data);
        setGetCity(data?.Response[0]?.installationAddress?.InstallCityName);

        console.log("data?.Response[0]?.companyDetail?.CompanyName", data?.Response[0]?.companyDetail?.CompanyName);

        setComName(data?.Response[0]?.companyDetail?.CompanyName);
        setCompanyId(data?.Response[0]?.CompanyId);
        // setRelationShipId(data.Response[0].RelationshipId);
        setGetGroup(data?.Response[0]?.GroupId);


        let relationshipOptions1
        let companyOption1
        if (data?.Response[0]?.CompanyId) {
          relationshipOptions1 = await fetchRelationshipData(
            data?.Response[0]?.CompanyId
          );
          // console.log("relationshipOptions1",relationshipOptions1);
          setRelationshipOptions(relationshipOptions1);
          companyOption1 = await fetchCompanyData(
            data?.Response[0]?.CompanyId
          )
          setCompanyOptions(companyOption1)
        }
        // console.log("companyOption1",companyOption1);
        // console.log("companyOption1", companyOption1);


        // let selectedAreaCode1 = data.Response[0].installationAddress.InstallArea;
        //   if (selectedAreaCode1) { await fetchSocietyData(selectedAreaCode1);
        //     console.log("Society list has been updated.");
        //   }

        const selectedAreaCode = data?.Response[0]?.installationAddress?.InstallArea;
        if (selectedAreaCode) {
          const societyApiUrl = process.env.REACT_APP_API_URL_2;
          const societyRequestBody = {
            Action: "getsociety",
            Authkey: "AdgT6SnjAkeLqlkE4",
            areaCode: selectedAreaCode,
            password: sessionStorage.getItem("password"),
            userName: sessionStorage.getItem("userName"),
          };
          const societyResponse = await fetch(societyApiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(societyRequestBody),
          });
          const societyData = await societyResponse.json();
          // console.log("societyData.Response", societyData.Response);
          if (societyData.Response && Array.isArray(societyData.Response)) {
            const filterSociety = societyData.Response.find(item => item.SocietyCode === String(data.Response[0].installationAddress.InstallSociety));
            if (filterSociety) {
              setSelectSociety({
                value: data.Response[0].installationAddress.InstallSociety,
                label: filterSociety.SocietyName,
              });
            } else {
              console.error("Society not found");
            }
          }
        }

        setUserData({
          fullName : `${data.Response[0].FirstName} ${data.Response[0].LastName} `,
          firstName: data.Response[0].FirstName,
          lastName: data.Response[0].LastName,
          mobile: data.Response[0].MobileNo,
          email: data.Response[0].EmailId,
          block: data.Response[0].installationAddress.Block,
          houseNo: data.Response[0].installationAddress.InstallPlotNo,
          floor: data.Response[0].installationAddress.InstallFloor,
          portalCode: data.Response[0].installationAddress.InstallPincode,
          remark: data.Response[0].Remark,
        });


        setStatus(data?.Response[0]?.Status);
        setFlrStatus(data?.Response[0]?.FLRstatus);
        // console.log("data.Response[0].CompanyNameCompany", data.Response[0].CompanyNameCompany)
        // if (data.Response[0].CompanyNameCompany) {
        //   setSelectedCompany({
        //     value: data.Response[0].CompanyId,
        //     label: `${data.Response[0].CompanyNameCompany} (${data.Response[0].CompanyId})`,
        //   });
        // } else {
        //   setSelectedCompany({
        //     value: data.Response[0].CompanyId,
        //     label: `${data.Response[0].CompanyNameCompany}`,
        //   });
        // }
        const companyId = data?.Response[0]?.CompanyId;
        const GroupId = data?.Response[0]?.GroupId;


        const filterCompanyId = companyOption1 ? companyOption1?.find(item => String(item.value) === String(companyId)) : null;
        // console.log("filterRelationshipId",filterRelationshipId);
        const filterGroupId = companyOption1 ? companyOption1?.find(item => String(item.groupId) === String(GroupId)) : null;
        if (filterCompanyId) {
          setSelectedCompany({
            value: filterCompanyId ? filterCompanyId?.value : "",
            label: filterCompanyId ? filterCompanyId?.label : "",
          });
          setSelectedGroup({
            value: filterGroupId ? filterGroupId?.groupId : "",
            label: filterGroupId ? filterGroupId?.group : "",
          });
        } else {
          console.error("RelationshipId not found in relationshipOptions");
        }

        const relationshipId = data?.Response[0]?.RelationshipId;
        const filterRelationshipId = relationshipOptions1 ? relationshipOptions1?.find(item => String(item.value) === String(relationshipId)) : null;
        // console.log("filterRelationshipId",filterRelationshipId.label);
        if (filterRelationshipId) {
          setRelationShipId(filterRelationshipId.label)
          setSelectRelationship({
            value: filterRelationshipId ? filterRelationshipId?.value : "",
            label: filterRelationshipId ? filterRelationshipId?.label : "",
          });
        } else {
          console.error("RelationshipId not found in relationshipOptions");
        }

        const filterIndustryType = industryTypes?.find(
          (item) =>
            item.value === String(data?.Response[0]?.companyDetail?.IndustryType)
        ).label;
        setSelectIndustryType({
          value: data.Response[0]?.companyDetail?.IndustryType,
          label: filterIndustryType,
        });
        const filterSalutationId = optionSolutation?.find(
          (item) => item.value === String(data?.Response[0]?.SalutationId)
        ).label;
        setSelectSolutation({
          value: data?.Response[0]?.SalutationId,
          label: filterSalutationId,
        });


      } catch (error) {
        //console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [leadId, industryTypes]);

  const handleSubmit = async () => {

    const fullName = userData.fullName.trim(); // Get full name
    const words = fullName.split(" "); // Split into words
    const midIndex = Math.ceil(words.length / 2);

    const firstName = words.slice(0, midIndex).join(" ");
    const lastName = words.slice(midIndex).join(" ");

    // console.log("First Half:", firstName);
    // console.log("Second Half:", lastName);

    if (!selectedCompany) {
      toast.warning("Select Company", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectedGroup) {
      toast.warning("Select Group", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectRelationship) {
      toast.warning("Select Relationship", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectIndustryType) {
      toast.warning("Select Industry Type", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    //  else if (!selectFirmType) {
    //   toast.warning("Select Firm Type", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // }
    else if (selectSolutation.value === "0") {
      toast.warning("Select Salutation", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!userData.fullName) {
      toast.warning("Enter Full Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    // else if (!userData.lastName) {
    //   toast.warning("Enter Last Name", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // }
    else if (userData.mobile.length < 10) {
      toast.warning("Enter Mobile Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
    ) {
      toast.warning("Enter Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectState) {
      toast.warning("Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity) {
      toast.warning("Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea) {
      toast.warning("Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userData.houseNo) {
      toast.warning("Enter Plot", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userData.floor) {
      toast.warning("Enter Floor", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectSociety.length == 0) {
      toast.warning("Select Society", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!userData.portalCode) {
      toast.warning("Enter PinCode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (userData.portalCode.length < 6) {
      toast.warning("Enter PinCode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!userData.remark) {
      toast.warning("Enter Remark", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else {
      if (leadId) {
        setLoading(true);
        const leadUpdateUrl = process.env.REACT_APP_API_URL;
        const leadUpdationData = {
          "Action": "updateLead",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "CompanyDetail": {
            "companyName": selectedCompany
              ? selectedCompany.label.split("(")[0].trim()
              : "",
            "firmType": selectFirmType.value
              ? selectFirmType.value
              : "",
            "industryType": selectIndustryType.value
              ? selectIndustryType.value
              : "",
            "jobTitle": ""
          },
          "ContactAddress": {
            "contactArea": "",
            "contactBuilding": "",
            "contactCity": "",
            "contactCountry": "",
            "contactFloor": "",
            "contactPincode": "",
            "contactPlotNo": "",
            "contactSpecifyArea": "",
            "contactSpecifyBuilding": "",
            "contactState": "",
            "contactblock": ""
          },
          "InstallationAddress": {
            "block": userData.block ? userData.block : "",
            "installArea": selectArea
              ? selectArea.value
              : "",
            "installBuilding": "",
            "installCity": selectCity ? selectCity.value : "",
            "installCountry": "10001",
            "installFloor": userData.floor ? userData.floor : "",
            "installPincode": userData.portalCode ? userData.portalCode : "",
            "installPlotNo": userData.houseNo ? userData.houseNo : "",
            "installSociety": selectSociety ? selectSociety.value : "",
            "installSpecifyArea": "",
            "installSpecifyBuilding": "",
            "installState": selectState ? selectState.value : "",
          },
          "SDWAN": {
            "applicationsHosted": "",
            "currentOperationalCity": "",
            "customerBroadbandServices": "",
            "customerILLservices": "",
            "customerRoutingServices": "",
            "firewallSetToExpire": "",
            "indicationITSpent": "",
            "itSupport": "",
            "linksManagedLinks": "",
            "mPLSBackbone": "",
            "mPLSContract": "",
            "networkSecurityServices": "",
            "noOfLocation": "",
            "numberOfLinksBroadbandServices": "",
            "numberOfLinksIll": "",
            "redundancyMPLS": "",
            "sdwanRemarks": ""
          },
          "businessSegment": "Home",
          "companyID": selectedCompany ? selectedCompany.value : "",
          "contactPersonName": "",
          "customersegment": "",
          "emailId": userData.email ? userData.email : "",
          "ems": "",
          // "firstName": userData.firstName ? userData.firstName : "",
          "firstName": firstName,
          "groupID": selectedGroup ? selectedGroup.value : "",
          "isSameAddress": "",
          // "lastName": userData.lastName ? userData.lastName : "",
          "lastName": lastName,
          "leadChannel": selectLeadChannel?.value ? selectLeadChannel?.value : "",
          "leadId": leadId,
          "leadSource": selectSource?.value ? selectSource?.value : "",
          "leadTopic": userData.fullName ? userData.fullName : "",
          "mobileNo": userData.mobile ? userData.mobile : "",
          "otherDetail": {
            "currentWorkingLocation": "",
            "existingServiceProvider1": "",
            "existingServiceProvider2": "",
            "isDatacenter": "false",
            "isFirewall": "false",
            "isManagesWiFi": "false",
            "isVOIP": "false",
            "isVPN": "false",
            "media": "",
            "serviceFromServiceProvider1": "",
            "serviceFromServiceProvider2": "",
            "targetInstallationPeriod": ""
          },
          "password": sessionStorage.getItem("password"),
          "productName": "",
          "relationshipId": selectRelationship ? selectRelationship.value : "",
          "remark": userData.remark ? userData.remark : "",
          "salutationId": selectSolutation ? selectSolutation.value : "",
          "specifyleadsource": userData.specifyLeadSource ? userData.specifyLeadSource : "other",
          "subBusinessSegment": "FTTH",
          "userName": sessionStorage.getItem("userName"),
          "verticalID": ""
        }
        try {
          const response = await fetch(leadUpdateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(leadUpdationData),
          });
          //console.log('Request Payload:', JSON.stringify(leadUpdationData))
          const data = await response.json();
          // console.log('API Response lead create:', data);
          if (data.Response.Message === "Lead Updated Successfully") {
            setLoading(false);
            toast.success("Lead Updated Successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            navigate("/broadbandLead");
          } else {
            setLoading(false);
            toast.warning(data.Response.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } catch (error) {
          console.error("Error creating lead:", error);
          toast.error("An error occurred. Please try again later.", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      }
      else {
        setLoading(true);
        const leadCreateUrl = process.env.REACT_APP_API_URL;
        const leadCreationData = {
          Action: "createLead",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CompanyDetail: {
            companyName: selectedCompany
              ? selectedCompany.label.split("(")[0].trim()
              : "",
            firmType: selectFirmType.value
              ? selectFirmType.value
              : "",
            industryType: selectIndustryType.value
              ? selectIndustryType.value
              : "",
            jobTitle: "",
          },
          ContactAddress: {
            contactArea: "",
            contactBuilding: "",
            contactCity: "",
            contactCountry: "",
            contactFloor: "",
            contactPincode: "",
            contactPlotNo: "",
            contactSpecifyArea: "",
            contactSpecifyBuilding: "",
            contactState: "",
            contactblock: "",
          },
          InstallationAddress: {
            block: userData.block ? userData.block : "",
            installArea: selectArea
              ? selectArea.label.split("(")[1].split(")")[0].trim()
              : "",
            installBuilding: "",
            installCity: selectCity ? selectCity.value : "",
            installCountry: "10001",
            installFloor: userData.floor ? userData.floor : "",
            installPincode: userData.portalCode ? userData.portalCode : "",
            installPlotNo: userData.houseNo ? userData.houseNo : "",
            installSociety: selectSociety ? selectSociety.value : "",
            installSpecifyArea: "",
            installSpecifyBuilding: "",
            installState: selectState ? selectState.value : "",
          },
          SDWAN: {
            applicationsHosted: "",
            currentOperationalCity: "",
            customerBroadbandServices: "",
            customerILLservices: "",
            customerRoutingServices: "",
            firewallSetToExpire: "",
            indicationITSpent: "",
            itSupport: "",
            linksManagedLinks: "",
            mPLSBackbone: "",
            mPLSContract: "",
            networkSecurityServices: "",
            noOfLocation: "",
            numberOfLinksBroadbandServices: "",
            numberOfLinksIll: "",
            redundancyMPLS: "",
            sdwanRemarks: "",
          },
          businessSegment: "Home",
          companyID: selectedCompany ? selectedCompany.value : "",
          contactPersonName: userData.firstName ? userData.firstName : "",
          customersegment: "",
          emailId: userData.email ? userData.email : "",
          ems: "",
          firstName: firstName,
          groupID: selectedGroup ? selectedGroup.value : "",
          isSameAddress: "",
          lastName: lastName,
          leadChannel: "FFA APP",
          leadId: "",
          leadSource: selectSource ? selectSource.value : "",
          leadTopic: userData.fullName ? userData.fullName : "",
          mobileNo: userData.mobile ? userData.mobile : "",
          otherDetail: {
            currentWorkingLocation: "",
            existingServiceProvider1: "",
            existingServiceProvider2: "",
            isDatacenter: "false",
            isFirewall: "false",
            isManagesWiFi: "false",
            isVOIP: "false",
            isVPN: "false",
            media: "",
            serviceFromServiceProvider1: "",
            serviceFromServiceProvider2: "",
            targetInstallationPeriod: "",
          },
          password: sessionStorage.getItem("password"),
          productName: "",
          relationshipId: selectRelationship ? selectRelationship.value : "",
          remark: userData.remark ? userData.remark : "",
          salutationId: selectSolutation ? selectSolutation.value : "",
          specifyleadsource: userData.specifyLeadSource ? userData.specifyLeadSource : "other",
          subBusinessSegment: "FTTH",
          userName: sessionStorage.getItem("userName"),
          verticalID: "",
        };
        try {
          const response = await fetch(leadCreateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(leadCreationData),
          });
          //console.log('Request Payload:', JSON.stringify(leadCreationData))
          const data = await response.json();
          // console.log("API Response lead create:", data);
          if (data.Response.Message === "Lead Created Successfully") {
            setLoading(false);
            toast.success("Lead Created Successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            navigate("/broadbandLead");
          } else {
            setLoading(false);
            toast.warning(data.Response.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } catch (error) {
          console.error("Error creating lead:", error);
          toast.error("An error occurred. Please try again later.", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      }
    }
  };

  const handleSelectQualify = async (optionQualify) => {
    // console.log(optionQualify.value)
    if (optionQualify) {
      try {
        setLoading(true);
        const disqualifiedUrl = process.env.REACT_APP_API_URL;
        const disqualifiedData = {
          Action: "disqualifydLead",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          leadId: leadId,
          password: sessionStorage.getItem('password'),
          status: optionQualify.value, // Use the value of the selected option
          userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(disqualifiedUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(disqualifiedData),
        });
        const data = await response.json();
        if (data.Response.StatusCode === 200) {
          // alert("done");
          setLoading(false);
          toast.success("Lead DisQualified Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          navigate("/businessLead");
        } else {
          // alert(data.Response.Message);
          setLoading(false);
          toast.warning(data.Response.Message, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }
  };

  const handleQualifyLead = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getCompanyGroupDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        customerName: comName,
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName')
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      // console.log("companyId", companyId);
      // console.log("setGetDigiCompanyId", data.Response.CompanyID);

      setGetDigiCompanyId(data.Response.CompanyID);

      if (data.Response.StatusCode == 200 && companyId !== "CNew") {
        try {
          const apiUrl = process.env.REACT_APP_API_URL;
          const requestData = {
            "Action": "getCompanyRelationship",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "CompanyID": companyId ? companyId : "",
            "GroupID": getGroup ? getGroup : "",
            "City": getCity ? getCity : "",
            "password": sessionStorage.getItem('password'),
            "userName": sessionStorage.getItem('userName')
          };
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });
          const data = await response.json();
          // console.log("Response.RelationShipID", data.Response.RelationShipID);

          if (data?.Response?.StatusCode == 200 && relationShipId !== "10New") {
            // console.log("getCity",getCity);
            // console.log("relationShipId",relationShipId);
            if (getCity == relationShipId) {
              try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                  Action: "qualifyLead",
                  Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                  leadId: leadId,
                  password: sessionStorage.getItem('password'),
                  userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(requestData),
                });
                const data = await response.json();
                // console.log("API Response:", data);
                if (data.Response.StatusCode === 200) {
                  toast.success("Lead Qualify Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
                  navigate("/opportunity");
                } else {
                  toast.warning(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
                }
              } catch (error) {
                console.error("Error during API call:", error);
              }
            }

            else {
              Swal.fire({
                // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                text: "Selected City on Installation Address and Relationship ID must be same",
                confirmButtonText:
                  '<span style="font-size: 15px;">Ok</span>',
                confirmButtonColor: "rgb(148,101,170)",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  navigate(`/broadbandLeadForm?LeadId=${leadId}`);
                }
                else {
                  navigate(`/broadbandLeadForm?LeadId=${leadId}`);
                }
              })
            }
          } else if (data.Response.StatusCode == 200 && relationShipId == "10New") {
            Swal.fire({
              // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
              text: "Company & Relationship ID exist in CRM. Select and proceed with lead qualification.",
              confirmButtonText:
                '<span style="font-size: 15px;">Ok</span>',
              confirmButtonColor: "rgb(148,101,170)",
            }).then(async (result) => {
              if (result.isConfirmed) {
                navigate(`/broadbandLeadForm?LeadId=${leadId}`);
              }
              else {
                navigate(`/broadbandLeadForm?LeadId=${leadId}`);
              }
            })
          } else if (data.Response.StatusCode == 400 && data.Response.RelationShipID == "") {
            try {
              const apiUrl = process.env.REACT_APP_API_URL;
              const requestData = {
                Action: "qualifyLead",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                leadId: leadId,
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
              };
              const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
              });
              const data = await response.json();
              // console.log("API Response:", data);
              if (data.Response.StatusCode === 200) {
                toast.success("Lead Qualify Successfully", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
                navigate("/opportunity");
              } else {
                toast.warning(data.Response.Message, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
              }
            } catch (error) {
              console.error("Error during API call:", error);
            }
          }
        } catch (error) {
          console.error("Error during API call:", error);
        }

      } else if (data.Response.StatusCode == 400 && getDigiCompanyId == "" && data.Response.Message !== "Please pass valid customer name.") {
        try {
          const apiUrl = process.env.REACT_APP_API_URL;
          const requestData = {
            Action: "qualifyLead",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            leadId: leadId,
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName'),
          };
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });
          const data = await response.json();
          // console.log("API Response:", data);
          if (data.Response.StatusCode === 200) {
            toast.success("Lead Qualify Successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            navigate("/opportunity");
          } else {
            toast.warning(data.Response.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } catch (error) {
          console.error("Error during API call:", error);
        }
      } else if (data.Response.StatusCode == 200 && companyId == "CNew") {

        Swal.fire({
          // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
          text: "Company and Group hierarchy already exists in CRM, Please select the same and proceed for lead qualification",
          confirmButtonText:
            '<span style="font-size: 15px;">Ok</span>',
          confirmButtonColor: "rgb(148,101,170)",
        }).then(async (result) => {
          if (result.isConfirmed) {
            navigate(`/broadbandLeadForm?LeadId=${leadId}`);
          }
          else {
            navigate(`/broadbandLeadForm?LeadId=${leadId}`);
          }
        })
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.warning(error, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDisqualify = () => {

  }

  const navigate = useNavigate();
  const redirectLeadPage = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/broadbandLead");
      } else {
        navigate(`/broadbandLeadForm?LeadId=${leadId}`);
      }
    });
  };


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "black",
      color: "white",
      border: "none",
      boxShadow: state.isFocused ? "none" : provided.boxShadow,
      textAlign: "center",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
    }),
    option: (provided, state) => ({
      ...provided,
      // backgroundColor: state.isFocused ? 'blue' : 'black',
      color: "black",
      textAlign: "center",
    }),
  };

  const redirectBroadbandCAFPage = () => {
    navigate(`/broadbandCAFmanageForm?LeadId=${leadId}`)
  }

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectLeadPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Lead Details</span>
          {/* {leadId &&
            <span
              className="float-end"
              style={{ fontSize: "12px", color: "black", cursor: "pointer" }}
              onClick={redirectBroadbandCAFPage}
            >
              <p

                className="m-1 text-center"
                style={{ backgroundColor: "white", padding: "3px", width: "100%" }}

              >
                Create CAF
              </p>
            </span>} */}

        </div>
      </div>
      {/* ************Header end************ */}


      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={load} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid form-container">

        {(status !== "1" && status !== "2") &&(
          <Select
            className="basic-single disqualify-select"
            classNamePrefix="select"
            name="subBusiness"
            // value={selectQualify}
            isSearchable={false}
            styles={customStyles}
            value={{ value: "", label: "Disqualify" }} // Value should be an object with 'value' and 'label' properties
            onChange={handleSelectQualify}
            options={optionQualify.map((data) => ({
              value: data.code,
              label: data.name,
            }))}
          />)}

  
            {status =="0" ? (
          <button
            className="btn w-100 mt-2 qualify-btn text-light"
            onClick={handleQualifyLead}
          >
            Qualify
          </button>) : ("")}



          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form1")}
          >
            <span className="toggle-text">Personal Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {openForm === "form1" && (
            <div
              className=" container shadow  mb-3 bg-body rounded mt-4"
              id="form1"
            >
              <form className="contact-form p-2">
                {/* {console.log("selectedCompany",selectedCompany)} */}
                <div className="">
                  <label className="select-search-label mt-1">Company*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="company"
                    value={selectedCompany}
                    onChange={handleCompanyChange}
                    options={companyOptions}
                    styles={style}
                    isSearchable={true}
                    isLoading={loader}
                    placeholder="Select Company"
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Group*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="group"
                    placeholder="Select Group"
                    value={selectedGroup}
                    onChange={handleGroupChange}
                    options={groupOptions}
                    styles={style}
                    isSearchable={true}
                    isLoading={loader}

                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Relationship*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="group"
                    value={selectRelationship ? selectRelationship : ""}
                    onChange={handleSelectRelationship}
                    options={relationshipOptions ? relationshipOptions : ""}
                    styles={style}
                    isSearchable={true}
                    isLoading={loader}
                    placeholder="Select Relationship"
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Industry Type*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="industryType"
                    placeholder="Select Industry"
                    styles={style}
                    value={selectIndustryType}
                    isSearchable={false}
                    onChange={handleSelectIndustryType}
                    options={industryTypes.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>



                {/* <div className="">
                  <label className="select-search-label mt-1">
                    Firm Type*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firmType"
                    placeholder="Select FirmType"
                    styles={style}
                    value={selectFirmType}
                    isSearchable={false}
                    onChange={handleSelectFirmType}
                    options={firmTypes.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div> */}

                <div className="">
                  <label className="select-search-label mt-1">
                    Salutation*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="Salutation"
                    placeholder="Select Salutation"
                    styles={style}
                    value={selectSolutation}
                    isSearchable={false}
                    onChange={handleSelectSolutation}
                    options={optionSolutation.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {/* <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="firstName"
                    value={userData.firstName}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    First Name*
                  </label>
                </div> */}

                {/* <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    className=" form-control input-text form-control-sm mt-1"
                    id="lastName"
                    name="lastName"
                    value={userData.lastName}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Last Name*
                  </label>
                </div> */}

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={userData.fullName}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Full Name*
                  </label>
                </div>

                {/* {console.log("userData.fullName", userData.fullName)} */}


                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="mobile"
                    name="mobile"
                    maxLength="10"
                    pattern="[0-9]{10}"
                    value={userData.mobile}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (userData.mobile.length < 10 || e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Mobile No*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="email"
                    placeholder="Enter Mobile Number"
                    className=" form-control input-text form-control-sm mt-1"
                    id="email"
                    name="email"
                    value={userData.email}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Email Id*
                  </label>
                </div>
              </form>
            </div>
          )}

          <div
            className="Installation-toggle  mt-3"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">Installation Address</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {openForm === "form2" && (
            <div
              className=" container shadow  mb-3 bg-body rounded mt-4"
              id="form2"
            >
              <form className="contact-form p-2">

                <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="state"
                    placeholder="Select State"
                    isSearchable={false}
                    styles={style}
                    value={selectState}
                    onChange={handleSelectState}
                    options={optionState.map((data) => ({
                      value: data.code,
                      label: data.name,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">City*</label>
                  <Select
                    className="basic-single form-control form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="City"
                    placeholder="Select City"
                    isSearchable={false}
                    styles={style}
                    // value={cityType.find(
                    //   (city) => city.CityCode === selectCity.value
                    // )}
                    value={selectCity}
                    onChange={handleSelectCity}
                    options={cityType.map((data) => ({
                      value: data.CityCode,
                      label: data.CityName,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Area*</label>
                  <Select
                    options={areaList.map((area) => ({
                      value: area.AreaCode,
                      label: `${area.AreaName} (${area.AreaCode})`,
                    }))}
                    className="basic-single  form-control form-control-sm p-1"
                    placeholder="Search Area"
                    styles={style}
                    isSearchable
                    value={selectArea}
                    onChange={handleSelectArea}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Society*</label>
                  <Select
                    className="basic-single form-control form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="Society"
                    placeholder="Select Society"
                    isSearchable
                    styles={style}
                    value={selectSociety}
                    onChange={handleSelectSociety}
                    options={societyList.map((data) => ({
                      value: data.SocietyCode,
                      label: data.SocietyName,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="block"
                    name="block"
                    value={userData.block}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Block/Tower
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="houseNo"
                    name="houseNo"
                    value={userData.houseNo}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    House/Plot/Flat No.*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="floor"
                    name="floor"
                    value={userData.floor}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Floor*
                  </label>
                </div>



                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="portalCode"
                    name="portalCode"
                    value={userData.portalCode}
                    onChange={handleChange}
                    maxLength="6"
                    pattern="[0-9]{10}"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (userData.portalCode.length < 6 ||
                          e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Postal Code*
                  </label>
                </div>
              </form>
            </div>
          )}

          <div
            className="Installation-toggle  mt-3"
            onClick={() => handleIconClick("form3")}
          >
            <span className="toggle-text">Remarks</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {openForm === "form3" && (
            <div
              className=" container shadow  mb-5 bg-body rounded mt-4"
              id="form3"
            >
              <form className="contact-form p-2">

                <div className="select-container mt-2">
                  <label className="select-search-label">Channel*</label>
                  <Select
                    className=" basic-single form-control form-control-sm  p-1"
                    classNamePrefix="select"
                    name="leadChannel"
                    placeholder="Select"
                    styles={style}
                    value={selectLeadChannel}
                    isSearchable={false}
                    onChange={handleSelectChannel}
                    options={optionLeadChannel.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Source*</label>
                  <Select
                    className="basic-single form-control form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="Source"
                    placeholder="Select Source"
                    isSearchable
                    styles={style}
                    value={selectSource}
                    onChange={handleSelectSource}
                    options={optionSource.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {selectSource && selectSource?.label?.includes("Other") ? (
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="specifyLeadSource"
                  name="specifyLeadSource"
                  value={userData.specifyLeadSource}
                  style={{ background: "transparent" }}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Specify Lead Source
                </label>
              </div>) : null} 

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="remark"
                    name="remark"
                    value={userData.remark}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Remarks*
                  </label>
                </div>
              </form>
            </div>
          )}

          <div className=" text-center mt-5 mb-3">
            <button
              type="submit"
              className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BroadbandLeadForm;
